import {
  authorizeMarketplaceInstall,
  getInstallations,
  newInstallation,
} from "../network/actions/installation.actions";
import { LIMIT_LIST_UNLIMITED } from "./utils";

export const MARKETPLACE_RETURN_URL_PARAM = "hubspotMarketplaceReturnUrl";
export const MARKETPLACE_RETURN_URL_STORAGE_KEY = "hubspot_marketplace_return_url";
export const MARKETPLACE_INSTALLATION_NAME = "Sample Installation";
export const MARKETPLACE_WIZARD_STATE = { installationStep: "hubspot-login" } as const;

let continuationPromise: Promise<string | null> | null = null;

export const captureMarketplaceReturnUrl = (search: string): void => {
  const returnUrl = new URLSearchParams(search).get(MARKETPLACE_RETURN_URL_PARAM);
  if (returnUrl) sessionStorage.setItem(MARKETPLACE_RETURN_URL_STORAGE_KEY, returnUrl);
};

export const hasMarketplaceInstall = (): boolean =>
  Boolean(sessionStorage.getItem(MARKETPLACE_RETURN_URL_STORAGE_KEY));

const runMarketplaceInstallContinuation = async (): Promise<string | null> => {
  const returnUrl = sessionStorage.getItem(MARKETPLACE_RETURN_URL_STORAGE_KEY);
  if (!returnUrl) return null;

  const installations = await getInstallations({
    skip: 0,
    limit: LIMIT_LIST_UNLIMITED,
    sort: null,
    filters: null,
  });
  const existingInstallation = installations.data.find(
    (installation) => installation.name === MARKETPLACE_INSTALLATION_NAME
  );
  const installation = existingInstallation ?? await newInstallation({
    name: MARKETPLACE_INSTALLATION_NAME,
  });
  return `/installations/${installation.id!}#hubspot-login`;
};

export const continueMarketplaceInstall = (): Promise<string | null> => {
  if (!continuationPromise) {
    continuationPromise = runMarketplaceInstallContinuation().finally(() => {
      continuationPromise = null;
    });
  }

  return continuationPromise;
};

export const authorizeMarketplaceInstallation = async (installationId: string): Promise<string | null> => {
  const returnUrl = sessionStorage.getItem(MARKETPLACE_RETURN_URL_STORAGE_KEY);
  if (!returnUrl) return null;

  const authorization = await authorizeMarketplaceInstall(installationId, returnUrl);
  sessionStorage.removeItem(MARKETPLACE_RETURN_URL_STORAGE_KEY);
  return authorization.redirectUrl;
};
